
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

interface Product {
  id: number;
  name: string;
  category: string;
  categoryNL: string;
  description: string;
  descriptionNL: string;
  features: string[];
  featuresNL: string[];
  image: string;
  userCount: string;
  userCountNL: string;
  deployment: string;
}

const products: Product[] = [
  {
    id: 1,
    name: 'Creative Cloud All Apps',
    category: 'Complete Suite',
    categoryNL: 'Compleet Pakket',
    description:
      'Access to 20+ creative apps including Photoshop, Illustrator, InDesign, Premiere Pro, and more.',
    descriptionNL:
      'Toegang tot 20+ creatieve apps waaronder Photoshop, Illustrator, InDesign, Premiere Pro en meer.',
    features: ['All Adobe apps', '100GB cloud storage', 'Adobe Fonts', 'Portfolio website'],
    featuresNL: ['Alle Adobe-apps', '100GB cloudopslag', 'Adobe Fonts', 'Portfoliowebsite'],
    image:
      'https://public.readdy.ai/ai/img_res/2cdb82a05aa53d11de8ad3fcaff61523.jpg',
    userCount: 'Individual',
    userCountNL: 'Individueel',
    deployment: 'Cloud',
  },
  {
    id: 2,
    name: 'Photoshop',
    category: 'Photography',
    categoryNL: 'Fotografie',
    description:
      'Industry-standard image editing and compositing software for photographers and designers.',
    descriptionNL:
      'Industriestandaard beeldbewerkings- en compositiesoftware voor fotografen en ontwerpers.',
    features: ['Advanced editing', 'AI-powered tools', 'Cloud documents', 'Mobile integration'],
    featuresNL: ['Geavanceerde bewerking', 'AI-gestuurde tools', 'Clouddocumenten', 'Mobiele integratie'],
    image:
      'https://readdy.ai/api/search-image?query=Adobe%20Photoshop%20application%20interface%20with%20photo%20editing%20tools%20and%20layers%20panel%20on%20a%20clean%20white%20background%2C%20professional%20photography%20software%2C%20modern%20design%20aesthetic&width=400&height=300&seq=acc2&orientation=landscape',
    userCount: 'Individual',
    userCountNL: 'Individueel',
    deployment: 'Cloud',
  },
  {
    id: 3,
    name: 'Illustrator',
    category: 'Design',
    categoryNL: 'Ontwerp',
    description:
      'Vector graphics software for creating logos, icons, illustrations, and complex artwork.',
    descriptionNL:
      "Vectorgrafische software voor het maken van logo's, pictogrammen, illustraties en complex kunstwerk.",
    features: ['Vector editing', 'Typography tools', 'Color management', 'Export options'],
    featuresNL: ['Vectorbewerking', 'Typografietools', 'Kleurbeheer', 'Exportopties'],
    image:
      'https://readdy.ai/api/search-image?query=Adobe%20Illustrator%20vector%20design%20software%20interface%20with%20geometric%20shapes%20and%20bezier%20curves%20on%20a%20clean%20white%20background%2C%20professional%20graphic%20design%20tool%2C%20modern%20interface&width=400&height=300&seq=acc3&orientation=landscape',
    userCount: 'Individual',
    userCountNL: 'Individueel',
    deployment: 'Cloud',
  },
  {
    id: 4,
    name: 'InDesign',
    category: 'Publishing',
    categoryNL: 'Publicatie',
    description:
      'Page layout and desktop publishing software for print and digital media.',
    descriptionNL:
      'Paginalay-out en desktop publishing software voor print- en digitale media.',
    features: ['Layout design', 'Typography', 'Digital publishing', 'Print production'],
    featuresNL: ['Lay-outontwerp', 'Typografie', 'Digitale publicatie', 'Drukproductie'],
    image:
      'https://readdy.ai/api/search-image?query=Adobe%20InDesign%20page%20layout%20software%20interface%20with%20magazine%20spread%20and%20text%20columns%20on%20a%20clean%20white%20background%2C%20professional%20publishing%20tool%2C%20modern%20design&width=400&height=300&seq=acc4&orientation=landscape',
    userCount: 'Individual',
    userCountNL: 'Individueel',
    deployment: 'Cloud',
  },
  {
    id: 5,
    name: 'Premiere Pro',
    category: 'Video',
    categoryNL: 'Video',
    description:
      'Professional video editing software for film, TV, and web content creation.',
    descriptionNL:
      'Professionele videobewerkingssoftware voor film-, tv- en webcontentcreatie.',
    features: ['Timeline editing', 'Color grading', 'Audio mixing', 'Multi-cam editing'],
    featuresNL: ['Tijdlijnbewerking', 'Kleurcorrectie', 'Audiomixing', 'Multi-cam bewerking'],
    image:
      'https://readdy.ai/api/search-image?query=Adobe%20Premiere%20Pro%20video%20editing%20software%20interface%20with%20timeline%20and%20preview%20window%20on%20a%20clean%20white%20background%2C%20professional%20video%20production%20tool%2C%20modern%20interface%20design&width=400&height=300&seq=acc5&orientation=landscape',
    userCount: 'Individual',
    userCountNL: 'Individueel',
    deployment: 'Cloud',
  },
  {
    id: 6,
    name: 'After Effects',
    category: 'Video',
    categoryNL: 'Video',
    description:
      'Motion graphics and visual effects software for creating animations and composites.',
    descriptionNL:
      'Motion graphics en visuele effecten software voor het maken van animaties en composities.',
    features: ['Motion graphics', 'Visual effects', 'Animation tools', '3D compositing'],
    featuresNL: ['Motion graphics', 'Visuele effecten', 'Animatietools', '3D-compositing'],
    image:
      'https://readdy.ai/api/search-image?query=Adobe%20After%20Effects%20motion%20graphics%20software%20interface%20with%20animation%20timeline%20and%20effects%20panel%20on%20a%20clean%20white%20background%2C%20professional%20VFX%20tool%2C%20modern%20design&width=400&height=300&seq=acc6&orientation=landscape',
    userCount: 'Individual',
    userCountNL: 'Individueel',
    deployment: 'Cloud',
  },
  {
    id: 7,
    name: 'Lightroom',
    category: 'Photography',
    categoryNL: 'Fotografie',
    description:
      'Photo editing and organization software for photographers of all levels.',
    descriptionNL:
      'Fotobewerkings- en organisatiesoftware voor fotografen van alle niveaus.',
    features: ['Photo organization', 'Non-destructive editing', 'Presets', 'Cloud sync'],
    featuresNL: ['Foto-organisatie', 'Niet-destructieve bewerking', 'Voorinstellingen', 'Cloudsynchronisatie'],
    image:
      'https://readdy.ai/api/search-image?query=Adobe%20Lightroom%20photo%20editing%20software%20interface%20with%20image%20gallery%20and%20adjustment%20sliders%20on%20a%20clean%20white%20background%2C%20professional%20photography%20tool%2C%20modern%20interface&width=400&height=300&seq=acc7&orientation=landscape',
    userCount: 'Individual',
    userCountNL: 'Individueel',
    deployment: 'Cloud',
  },
  {
    id: 8,
    name: 'XD',
    category: 'Design',
    categoryNL: 'Ontwerp',
    description: 'UI/UX design and prototyping tool for websites and mobile apps.',
    descriptionNL:
      'UI/UX-ontwerp- en prototypingtool voor websites en mobiele apps.',
    features: ['Prototyping', 'Design systems', 'Collaboration', 'Developer handoff'],
    featuresNL: ['Prototyping', 'Ontwerpsystemen', 'Samenwerking', 'Ontwikkelaarsoverdracht'],
    image:
      'https://readdy.ai/api/search-image?query=Adobe%20XD%20user%20interface%20design%20software%20with%20mobile%20app%20mockups%20and%20artboards%20on%20a%20clean%20white%20background%2C%20professional%20UX%20design%20tool%2C%20modern%20interface&width=400&height=300&seq=acc8&orientation=landscape',
    userCount: 'Individual',
    userCountNL: 'Individueel',
    deployment: 'Cloud',
  },
  {
    id: 9,
    name: 'Acrobat Pro',
    category: 'Document',
    categoryNL: 'Document',
    description:
      'Complete PDF solution for creating, editing, and signing documents.',
    descriptionNL:
      'Complete PDF-oplossing voor het maken, bewerken en ondertekenen van documenten.',
    features: ['PDF editing', 'E-signatures', 'Form creation', 'Document security'],
    featuresNL: ['PDF-bewerking', 'E-handtekeningen', 'Formulieren maken', 'Documentbeveiliging'],
    image:
      'https://readdy.ai/api/search-image?query=Adobe%20Acrobat%20Pro%20PDF%20software%20interface%20with%20document%20viewer%20and%20editing%20tools%20on%20a%20clean%20white%20background%2C%20professional%20document%20management%20tool%2C%20modern%20design&width=400&height=300&seq=acc9&orientation=landscape',
    userCount: 'Individual',
    userCountNL: 'Individueel',
    deployment: 'Cloud',
  },
  {
    id: 10,
    name: 'Creative Cloud for Teams',
    category: 'Complete Suite',
    categoryNL: 'Compleet Pakket',
    description:
      'All Creative Cloud apps with team collaboration features and centralized management.',
    descriptionNL:
      'Alle Creative Cloud-apps met teamsamenwerking en gecentraliseerd beheer.',
    features: ['All Adobe apps', '1TB cloud storage', 'Admin console', 'Team collaboration'],
    featuresNL: ['Alle Adobe-apps', '1TB cloudopslag', 'Beheerconsole', 'Teamsamenwerking'],
    image:
      'https://readdy.ai/api/search-image?query=Adobe%20Creative%20Cloud%20for%20teams%20with%20multiple%20user%20icons%20and%20collaboration%20features%20on%20a%20clean%20white%20background%2C%20professional%20team%20software%2C%20modern%20interface%20design&width=400&height=300&seq=acc10&orientation=landscape',
    userCount: 'Team',
    userCountNL: 'Team',
    deployment: 'Cloud',
  },
  {
    id: 11,
    name: 'Dreamweaver',
    category: 'Web',
    categoryNL: 'Web',
    description:
      'Web design and development tool for creating responsive websites.',
    descriptionNL:
      'Webontwerp- en ontwikkeltool voor het maken van responsieve websites.',
    features: ['Code editor', 'Visual design', 'Responsive preview', 'Git support'],
    featuresNL: ['Code-editor', 'Visueel ontwerp', 'Responsieve voorvertoning', 'Git-ondersteuning'],
    image:
      'https://readdy.ai/api/search-image?query=Adobe%20Dreamweaver%20web%20development%20software%20interface%20with%20code%20editor%20and%20website%20preview%20on%20a%20clean%20white%20background%2C%20professional%20web%20design%20tool%2C%20modern%20interface&width=400&height=300&seq=acc11&orientation=landscape',
    userCount: 'Individual',
    userCountNL: 'Individueel',
    deployment: 'Cloud',
  },
  {
    id: 12,
    name: 'Animate',
    category: 'Animation',
    categoryNL: 'Animatie',
    description:
      'Interactive animation software for creating vector animations and interactive content.',
    descriptionNL:
      'Interactieve animatiesoftware voor het maken van vectoranimaties en interactieve content.',
    features: ['Vector animation', 'Interactive content', 'HTML5 Canvas', 'Character rigging'],
    featuresNL: ['Vectoranimatie', 'Interactieve content', 'HTML5 Canvas', 'Personage-rigging'],
    image:
      'https://readdy.ai/api/search-image?query=Adobe%20Animate%20animation%20software%20interface%20with%20timeline%20and%20character%20animation%20on%20a%20clean%20white%20background%2C%20professional%20animation%20tool%2C%20modern%20design&width=400&height=300&seq=acc12&orientation=landscape',
    userCount: 'Individual',
    userCountNL: 'Individueel',
    deployment: 'Cloud',
  },
];

const categoriesEN = [
  'Complete Suite',
  'Photography',
  'Design',
  'Publishing',
  'Video',
  'Document',
  'Web',
  'Animation',
];
const categoriesNL = [
  'Compleet Pakket',
  'Fotografie',
  'Ontwerp',
  'Publicatie',
  'Video',
  'Document',
  'Web',
  'Animatie',
];
const categoryMap: Record<string, string> = {
  'Compleet Pakket': 'Complete Suite',
  Fotografie: 'Photography',
  Ontwerp: 'Design',
  Publicatie: 'Publishing',
  Video: 'Video',
  Document: 'Document',
  Web: 'Web',
  Animatie: 'Animation',
};

const userCountsEN = ['Individual', 'Team'];
const userCountsNL = ['Individueel', 'Team'];
const userCountMap: Record<string, string> = {
  Individueel: 'Individual',
  Team: 'Team',
};

export default function AdobeCreativeCloudPage() {
  const location = useLocation();
  const isNL = location.pathname.startsWith('/nl');
  const prefix = isNL ? '/nl' : '';

  const categories = isNL ? categoriesNL : categoriesEN;
  const userCounts = isNL ? userCountsNL : userCountsEN;
  const deployments = ['Cloud'];

  const [filteredProducts, setFilteredProducts] = useState<Product[]>(products);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedUserCount, setSelectedUserCount] = useState<string[]>([]);
  const [selectedDeployment, setSelectedDeployment] = useState<string[]>([]);
  const [sortBy, setSortBy] = useState('name');

  useEffect(() => {
    try {
      let filtered = [...products];

      if (selectedCategories.length > 0) {
        const resolvedCategories = isNL
          ? selectedCategories.map((c) => categoryMap[c] || c)
          : selectedCategories;
        filtered = filtered.filter((p) => resolvedCategories.includes(p.category));
      }

      if (selectedUserCount.length > 0) {
        const resolvedCounts = isNL
          ? selectedUserCount.map((c) => userCountMap[c] || c)
          : selectedUserCount;
        filtered = filtered.filter((p) => resolvedCounts.includes(p.userCount));
      }

      if (selectedDeployment.length > 0) {
        filtered = filtered.filter((p) => selectedDeployment.includes(p.deployment));
      }

      filtered.sort((a, b) => {
        if (sortBy === 'name') return a.name.localeCompare(b.name);
        if (sortBy === 'name-desc') return b.name.localeCompare(a.name);
        return 0;
      });

      setFilteredProducts(filtered);
    } catch (error) {
      console.error('Error while filtering products:', error);
      setFilteredProducts([]);
    }
  }, [selectedCategories, selectedUserCount, selectedDeployment, sortBy, isNL]);

  const handleCategoryChange = (category: string) => {
    setSelectedCategories((prev) =>
      prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
    );
  };

  const handleUserCountChange = (count: string) => {
    setSelectedUserCount((prev) =>
      prev.includes(count) ? prev.filter((c) => c !== count) : [...prev, count]
    );
  };

  const handleDeploymentChange = (deployment: string) => {
    setSelectedDeployment((prev) =>
      prev.includes(deployment) ? prev.filter((d) => d !== deployment) : [...prev, deployment]
    );
  };

  const clearFilters = () => {
    setSelectedCategories([]);
    setSelectedUserCount([]);
    setSelectedDeployment([]);
    setSortBy('name');
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-red-600 via-purple-600 to-blue-600 text-white py-24">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">Adobe Creative Cloud</h1>
            <p className="text-xl mb-8 text-white/90">
              {isNL
                ? 'Ontketen uw creativiteit met toonaangevende creatieve applicaties. Van fotobewerking tot videoproductie, ontwerp tot webontwikkeling.'
                : 'Unleash your creativity with industry-leading creative applications. From photo editing to video production, design to web development.'}
            </p>
            <Link
              to={`${prefix}/contact`}
              className="inline-block bg-white text-purple-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              {isNL ? 'Aan de Slag' : 'Get Started'}
            </Link>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Filters Sidebar */}
            <aside className="lg:w-64 flex-shrink-0">
              <div className="bg-gray-50 rounded-lg p-6 sticky top-24">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-lg font-semibold text-gray-900">{isNL ? 'Filters' : 'Filters'}</h3>
                  <button
                    onClick={clearFilters}
                    className="text-sm text-purple-600 hover:text-purple-700 cursor-pointer whitespace-nowrap"
                  >
                    {isNL ? 'Alles Wissen' : 'Clear All'}
                  </button>
                </div>

                {/* Category Filter */}
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3">{isNL ? 'Categorie' : 'Category'}</h4>
                  <div className="space-y-2">
                    {categories.map((category) => (
                      <label key={category} className="flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedCategories.includes(category)}
                          onChange={() => handleCategoryChange(category)}
                          className="w-4 h-4 text-purple-600 rounded cursor-pointer"
                        />
                        <span className="ml-2 text-sm text-gray-700">{category}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* User Count Filter */}
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3">{isNL ? 'Licentietype' : 'License Type'}</h4>
                  <div className="space-y-2">
                    {userCounts.map((count) => (
                      <label key={count} className="flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedUserCount.includes(count)}
                          onChange={() => handleUserCountChange(count)}
                          className="w-4 h-4 text-purple-600 rounded cursor-pointer"
                        />
                        <span className="ml-2 text-sm text-gray-700">{count}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Deployment Filter */}
                <div>
                  <h4 className="font-semibold text-gray-900 mb-3">{isNL ? 'Implementatie' : 'Deployment'}</h4>
                  <div className="space-y-2">
                    {deployments.map((deployment) => (
                      <label key={deployment} className="flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedDeployment.includes(deployment)}
                          onChange={() => handleDeploymentChange(deployment)}
                          className="w-4 h-4 text-purple-600 rounded cursor-pointer"
                        />
                        <span className="ml-2 text-sm text-gray-700">{deployment}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            </aside>

            {/* Products Grid */}
            <div className="flex-1">
              {/* Sort and Results */}
              <div className="flex items-center justify-between mb-6">
                <p className="text-gray-600">
                  {isNL
                    ? `${filteredProducts.length} van ${products.length} producten weergegeven`
                    : `Showing ${filteredProducts.length} of ${products.length} products`}
                </p>
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="px-4 py-2 border border-gray-300 rounded-lg text-sm cursor-pointer"
                >
                  <option value="name">{isNL ? 'Naam: A tot Z' : 'Name: A to Z'}</option>
                  <option value="name-desc">{isNL ? 'Naam: Z tot A' : 'Name: Z to A'}</option>
                </select>
              </div>

              {/* Products Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                {filteredProducts.map((product) => (
                  <div
                    key={product.id}
                    className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow"
                  >
                    <div className="w-full h-48 bg-gray-100">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="p-6">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-xs font-semibold text-purple-600 bg-purple-50 px-2 py-1 rounded whitespace-nowrap">
                          {isNL ? product.categoryNL : product.category}
                        </span>
                        <span className="text-xs text-gray-500">
                          {isNL ? product.userCountNL : product.userCount}
                        </span>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">{product.name}</h3>
                      <p className="text-sm text-gray-600 mb-4">
                        {isNL ? product.descriptionNL : product.description}
                      </p>

                      <ul className="space-y-1 mb-4">
                        {(isNL ? product.featuresNL : product.features)
                          .slice(0, 3)
                          .map((feature, idx) => (
                            <li key={idx} className="text-sm text-gray-600 flex items-start">
                              <i className="ri-check-line text-green-600 mr-2 mt-0.5"></i>
                              {feature}
                            </li>
                          ))}
                      </ul>

                      <Link
                        to={`${prefix}/contact`}
                        className="block w-full bg-purple-600 text-white text-center px-4 py-2 rounded-lg font-semibold hover:bg-purple-700 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {isNL ? 'Offerte Aanvragen' : 'Request a Quote'}
                      </Link>
                    </div>
                  </div>
                ))}
              </div>

              {filteredProducts.length === 0 && (
                <div className="text-center py-12">
                  <i className="ri-inbox-line text-6xl text-gray-300 mb-4"></i>
                  <p className="text-gray-600">
                    {isNL
                      ? 'Geen producten gevonden die overeenkomen met uw filters.'
                      : 'No products found matching your filters.'}
                  </p>
                  <button
                    onClick={clearFilters}
                    className="mt-4 text-purple-600 hover:text-purple-700 font-semibold cursor-pointer whitespace-nowrap"
                  >
                    {isNL ? 'Filters Wissen' : 'Clear Filters'}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
